import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import Content from './Content';

const styles = () => ({
  root: {},
});

const PlannerAccountOpeningAccountInformationTemplate = ({
  className,
  classes,
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={BaseOverrideNoHidden}
      resource={resource}
      layout={Content}
    />
  );
};

PlannerAccountOpeningAccountInformationTemplate.defaultProps = {
  className: '',
};

PlannerAccountOpeningAccountInformationTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(PlannerAccountOpeningAccountInformationTemplate);
